"use strict";

exports.__esModule = true;
exports.maxLength = void 0;

var _util = require("../util");

var maxLength = (0, _util.wrapSyncFunc)(function (rule, value) {
  var maxLength = rule.maxLength,
      _rule$maxLengthType = rule.maxLengthType,
      maxLengthType = _rule$maxLengthType === void 0 ? 'char' : _rule$maxLengthType;

  if (maxLength == null) {
    return;
  }

  if (typeof value === 'string' && value !== '') {
    var str = 'byte' === maxLengthType ? value.replace(/[^\x00-\xff]/g, '01') : value;
    return str.length <= +maxLength;
  }
});
exports.maxLength = maxLength;